export enum PushNotificationPlatform {
    IOS = 'ios',
    ANDROID = 'android',
}